import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter as Router, Routes, Route, Link, Navigate, useLocation } from "react-router-dom";
import CookieConsent from 'react-cookie-consent';

// +++ NEUE IMPORTS +++
import S7MyPaymentMethods from './components/S7MyPaymentMethods';
import S8MyAgreements from './components/S8MyAgreements';
import S9MyEmailTemplates from './components/S9MyEmailTemplates';
// +++ ENDE NEUE IMPORTS +++

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import 'react-quill/dist/quill.snow.css';
import FEATURES from "./config/features";

// Alle Komponenten-Imports
import Login from "./components/Login";
import TwoFactorSetup from "./components/TwoFactorSetup";
import Register from "./components/Register";
import Home from "./components/Home";
import Profile from "./components/Profile";
import BoardAdmin from "./components/BoardAdmin";
import BoardTaxes from "./components/BoardTaxes";
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Navbar, Nav, Container } from 'react-bootstrap';
import mynLogo from './assets/myn-logo-full.svg';
import BoardMainVos from "./components/BoardMainVos";
import BoardSubVos from "./components/M1MyReseller";
import BoardAreaGroup from "./components/BoardAreaGroup";
import BoardArea from "./components/BoardArea";
import BoardCurrencies from "./components/BoardCurrencies";
import BoardServices from "./components/BoardServices";
import BoardFormTemplates from "./components/BoardFormTemplates";
import SystemVereinbarungsvorlage from "./components/SystemVereinbarungsvorlage";
import BoardProduction from "./components/BoardProduction";
import BoardStatus from "./components/BoardStatus";
import BoardTransportTypes from "./components/BoardTransportTypes";
import BoardStartCreditTypes from "./components/BoardStartCreditTypes";
import BoardTariffs from "./components/M2S1MyTariffs";
import BoardRoles from "./components/BoardRoles";
import BoardUsers from "./components/BoardUsers";
import BoardDashboard from "./components/BoardDashboard";
import BoardBatchcodes from "./components/M4Batchcodes";
import BoardNotifications from "./components/BoardNotifications";
import BoardRequestData from "./components/BoardRequestData";
import BoardInvoiceSettings from "./components/BoardInvoiceSettings";
import { logout } from "./slices/auth";
import EventBus from "./common/EventBus";
import Impressum from "./components/Impressum";
import PaymentThanks from "./components/PaymentThanks";
import Datenschutz from "./components/Datenschutz";
import Agb from "./components/Agb";
import EmailConfirm from "./components/EmailConfirm";
import PasswordReset from "./components/PasswordReset";
import SetPassword from "./components/SetPassword";
import SelfServiceSignup from "./components/SelfServiceSignup";
import Footer from "./components/Footer";
import BatchManager from "./components/M3BatchManager";
import InvoiceManager from "./components/M5InvoiceManager";
import CountryManager from "./components/CountryManager";
import BatchRedirect from "./components/BatchRedirect";
import BatchLocked from "./components/BatchLocked";
import BoardAdm from "./components/S2MyEmployees";
import BoardCustomer from "./components/S3MyCustomers";
import BoardBatchesSubvos from "./components/S4BatchesRentManager";
import BoardBatchesOrderSubvos from "./components/S5RentedBatches";
import BoardSubvoInvoiceManager from "./components/S6MyInvoices";
import BoardCustomerInfo from "./components/BoardCustomerInfo";
import Dashboard from "./components/Dashboard";
import AccountPage from "./components/AccountPage";
import UserSidebar from "./components/UserSidebar";
import BoardMyDataADM from "./components/A1MyData";
import BatchCodeManager from "./components/A2MyBatches";
import CustomerManagerADM from "./components/A3MyCustomer";
import BatchOrderManagerADM from "./components/A4MyBatchOrders";
import InvoiceManagerADM from "./components/A5MyInvoices";
import BoardChangeMyPasswordADM from "./components/A6ChangeMyPassword";
import BatchCodeDemoADM from "./components/A7DemoBatches";
import BatchManagerCustomer from "./components/C6MyBatches";
import BoardEmployee from "./components/C1Employee";
import BoardChangeMyPasswordCustomer from "./components/C3ChangeMyPassword";
import CustomerClicks from "./components/C4MyClicks";
import CustomerEmployeeClicks from "./components/C5MyEmployiesClicks";
import CustomerClickManager from "./components/C7ClickManager";
import CustomerReviewsPage from "./components/C8MyReviews";
import InvoiceManagerCustomer from "./components/C9MyInvoices";
import VereinbarungDetail from './components/VereinbarungDetail';
import VereinbarungErstellen from './components/VereinbarungErstellen';
import VereinbarungBearbeiten from './components/VereinbarungBearbeiten';
import BoardVereinbarungstitel from './components/BoardVereinbarungstitel';
import BoardPlaceholderSync from './components/BoardPlaceholderSync';
import BoardDocumentTypes from './components/BoardDocumentTypes';
import BoardSystemTemplates from './components/BoardSystemTemplates';
import BoardTitelKatalog from './components/BoardTitelKatalog';
import BoardApiConfig from './components/BoardApiConfig';
import BoardAiConfigs from './components/BoardAiConfigs';
import BoardAiMasterData from './components/BoardAiMasterData';
import BoardSystemReset from './components/BoardSystemReset'; // Folgeprompt 17: Datenbereinigung / Werksreset
import BoardSelfServiceLive from './components/BoardSelfServiceLive'; // Systemadmin: Liste "Gerade erzeugt" verwalten
import BusinessCardDetail from './components/BusinessCardDetail'; // Werbeplatz & Visitenkarte (Vorbild oi.gg)

// Hinweis zur Zahlungsabwicklung:
// Der veroeffentlichbare Stripe-Schluessel wird ausschliesslich dort geladen,
// wo tatsaechlich bezahlt wird (siehe A7DemoBatches). Er stammt dort aus der
// Konfiguration der jeweiligen Zahlungsmethode in der Datenbank und wird
// gemeinsam mit dem clientSecret an eine eigene Elements-Instanz uebergeben.
// Ein globaler Schluessel an dieser Stelle waere weder zutreffend noch noetig:
// Er wuerde Stripe auf jeder Seite laden und bei abweichender Konfiguration
// den falschen Anbieterzugang verwenden.

const AppContent = () => {
  const [showAdminBoard, setShowAdminBoard] = useState(false);
  const [showMainvosBoard, setShowMainvosBoard] = useState(false);
  const [showSubvosBoard, setShowSubvosBoard] = useState(false);
  const [showAdmBoard, setShowAdmBoard] = useState(false);
  const [showCustomerBoard, setShowCustomerBoard] = useState(false);

  const { user: currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const logOut = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);

  useEffect(() => {
    if (currentUser) {
      setShowAdminBoard(currentUser.roles.includes("ROLE_ADMIN"));
      setShowMainvosBoard(currentUser.roles.includes("ROLE_MAINVO"));
      setShowSubvosBoard(currentUser.roles.includes("ROLE_SUBVO"));
      setShowAdmBoard(currentUser.roles.includes("ROLE_ADM"));
      setShowCustomerBoard(currentUser.roles.includes("ROLE_CUSTOMER"));

    } else {
      setShowAdminBoard(false);
      setShowMainvosBoard(false);
      setShowSubvosBoard(false);
      setShowAdmBoard(false);
      setShowCustomerBoard(false);
    }

    EventBus.on("logout", () => {
      logOut();
    });

    return () => {
      EventBus.remove("logout");
    };
  }, [currentUser, logOut]);

  const location = useLocation();
  const isFullWidth = location.pathname === "/" || location.pathname === "/home" || location.pathname === "/danke";

  return (
    <>
        <Navbar expand="lg" sticky="top" collapseOnSelect className="myn-rbnav">
          <Container fluid className="myn-rbnav__inner">
            <Navbar.Brand as={Link} to="/" className="myn-rbnav__brand">
              <img src={mynLogo} alt="MYN.CLUB" />
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="myn-navbar" aria-label="Menü öffnen" />

            <Navbar.Collapse id="myn-navbar">
              <Nav className="me-auto align-items-lg-center">
                <Nav.Link as={Link} to="/home">Startseite</Nav.Link>

                {/* Folgeprompt 16 (3.1): Einheitlicher, dauerhaft sichtbarer
                    Dashboard-Eintrag fuer JEDE Stufe. Eine Menue-Logik, gleiche
                    Zielroute (/customerinfo = konsolidiertes Dashboard); die
                    Unterschiede sind rein datengetrieben. Die fruehere, je Stufe
                    unterschiedliche Beschriftung (subVO Info / Employee Info /
                    Kundendaten / Admin-Board) entfaellt zugunsten dieses einen
                    Eintrags (keine Doppelung). */}
                {currentUser && (
                  <Nav.Link as={Link} to="/customerinfo">Dashboard</Nav.Link>
                )}

                {/* --- ANFANG: Finaler kombinierter Stammdaten-Dropdown --- */}
                {(showAdminBoard || showMainvosBoard || showSubvosBoard) && (
                  <NavDropdown title={showAdminBoard ? "Einstellungen" : "Stammdaten"} id="master-data-dropdown">

                    {/* Menüpunkte, die nur ADMINs sehen */}
                    {showAdminBoard && (
                      <>
                        <NavDropdown.Item as={Link} to="/system-templates">Systemtemplates</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/api-konfiguration">API-Konfiguration</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/ki-api">KI-API</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/gerade-erzeugt-verwalten">Gerade erzeugt verwalten</NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item as={Link} to="/system-reset" className="text-danger">🧹 Datenbereinigung / Werksreset</NavDropdown.Item>
                      </>
                    )}

                    {/* Menüpunkte, die nur MAINVOs sehen */}
                    {showMainvosBoard && (
                      <>
                        {showAdminBoard && <NavDropdown.Divider />}
                        <NavDropdown.Item as={Link} to="/subvos">Meine Reseller</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/tariffs">Meine Tarife</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/document-types">Belegartendefinitionen</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/invoice-settings">Rechnungsnummernformat</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/agreement-titles">Vereinbarungstitel</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/agreements">Vereinbarungen</NavDropdown.Item>
                      </>
                    )}

                    {/* Menüpunkte, die nur SUBVOs sehen */}
                    {showSubvosBoard && (
                      <>
                        {(showAdminBoard || showMainvosBoard) && <NavDropdown.Divider />}
                        <NavDropdown.Item as={Link} to="/tariffs">Meine Tarife</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/payment-methods">Meine Zahlungsarten</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/invoice-settings">Belegnummernformate</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/document-types">Belegartendefinitionen</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/agreement-titles">Vereinbarungstitel</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/agreements">Vereinbarungen</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/email-templates">Emailvorlagen</NavDropdown.Item>
                      </>
                    )}

                  </NavDropdown>
                )}
                {/* --- ENDE: Finaler kombinierter Stammdaten-Dropdown --- */}

                {showAdminBoard && (
                  <>
                    {/* Folgeprompt 16 (3.1): "Admin-Board" entfaellt; das Dashboard
                        ist jetzt der einheitliche Eintrag oben. */}
                    <Nav.Link as={Link} to="/produktion">Produktion</Nav.Link>
                    <NavDropdown title="Stammdaten" id="admin-settings-dropdown">
                      <NavDropdown.Item as={Link} to="/areagroup">Gebietsgruppe</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/areas">Gebiet</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/countries">Länder</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/currencies">Währungen</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/services">Dienste</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/transport-types">Transportarten</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/ai-stammdaten">KI-Stammdaten</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/start-credit-types">Startguthabenarten</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/taxes">Steuern</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/statuses">Statusobjekte</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/roles">Rollen</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/users">Benutzer</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/mainvos">Haupt-VO</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/notifications">Benachrichtigungen</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/requestdata">Weiterleitungen</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/system-title-catalog">Vereinbarungs-Titel</NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item as={Link} to="/invoice-settings">Rechnungsnummernformat</NavDropdown.Item>
                    </NavDropdown>
                  </>
                )}

                {showMainvosBoard && (
                  <NavDropdown title="Einstellungen" id="mainvo-settings-dropdown">
                    <NavDropdown.Item as={Link} to="/batchcodesmaster">Batch-Generator</NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/batchcodes">Batchcodes</NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/invoices">Erstellte Rechnungen</NavDropdown.Item>
                  </NavDropdown>
                )}

                {showSubvosBoard && (
                  <>
                    {/* Folgeprompt 16 (3.1): "subVO Info" entfaellt (Dashboard oben). */}
                    <NavDropdown title="Vertrieb" id="subvo-vertrieb-dropdown">
                      <NavDropdown.Item as={Link} to="/adm">Meine Vertriebspartner</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/customer">Meine Kunden</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/batchessubvos">Kommissionswarenmanager</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/batchesordersubvos">Kommissionierte Chargen</NavDropdown.Item>
                    </NavDropdown>
                    <NavDropdown title="Abrechnung" id="subvo-abrechnung-dropdown">
                      <NavDropdown.Item as={Link} to="/subvoinvoicemanager">Meine Rechnungen</NavDropdown.Item>
                    </NavDropdown>
                  </>
                )}

                {showAdmBoard && (
                  <>
                    {/* Folgeprompt 16 (3.1): "Employee Info" entfaellt (Dashboard oben). */}
                    <NavDropdown title="Einstellungen" id="adm-settings-dropdown">
                      <NavDropdown.Item href={"/admmydata"}>Meine Daten</NavDropdown.Item>
                      <NavDropdown.Item href={"/admbatches"}>Meine Chargen</NavDropdown.Item>
                      <NavDropdown.Item href={"/admcustomer"}>Meine Kunden</NavDropdown.Item>
                      <NavDropdown.Item href={"/admbatchorder"}>Meine Chargenaufträge</NavDropdown.Item>
                      <NavDropdown.Item href={"/adminvoicemanager"}>Meine Rechnungen</NavDropdown.Item>
                      <NavDropdown.Item href={"/admmypassword"}>Passwort ändern</NavDropdown.Item>
                      <NavDropdown.Item href={"/demobatches"}>Demochargen</NavDropdown.Item>
                    </NavDropdown>
                  </>
                )}

                {showCustomerBoard && (
                  <>
                    {/* Folgeprompt 16 (3.1): "Kundendaten" entfaellt (Dashboard oben). */}
                    <NavDropdown title="Einstellungen" id="customer-settings-dropdown">
                      <NavDropdown.Item href={"/employee"}>Mitarbeiter</NavDropdown.Item>
                      <NavDropdown.Item href={"/cstats"}>Meine Klicks</NavDropdown.Item>
                      <NavDropdown.Item href={"/cestats"}>Klicks meiner Mitarbeiter</NavDropdown.Item>
                      <NavDropdown.Item href={"/mybatches"}>Meine QR-Codes</NavDropdown.Item>
                      <NavDropdown.Item href={"/clickmanager"}>Klickverwaltung</NavDropdown.Item>
                      <NavDropdown.Item href={"/myreviews"}>Meine Bewertungen</NavDropdown.Item>
                      <NavDropdown.Item href={"/customervoicemanager"}>Meine Rechnungen</NavDropdown.Item>
                    </NavDropdown>
                  </>
                )}
              </Nav>

              <Nav className="ms-auto align-items-lg-center">
                {/* Folgeprompt 15: Eingeloggter Benutzer wird nicht mehr oben
                    rechts angezeigt. Username/Logout liegen jetzt einheitlich
                    unten links in der <UserSidebar/>. Nicht eingeloggt: weiterhin
                    Anmelden/Registrieren. */}
                {!currentUser && (
                  <>
                    <Nav.Link as={Link} to="/login">Anmelden</Nav.Link>
                    <Nav.Link as={Link} to="/register" className="myn-nav-cta">Registrieren</Nav.Link>
                  </>
                )}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        <div className={isFullWidth ? "myn-routes-full" : "container mt-3"}>
          <div className={isFullWidth ? "" : "myn-board-card"}>
          <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/2fa-einrichten" element={<TwoFactorSetup />} />
              <Route path="/register" element={FEATURES.legacyRegister ? <Register /> : <Navigate to="/selbst-buchen" replace />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/danke" element={<PaymentThanks />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/agb" element={<Agb />} />
              <Route path="/email-bestaetigen" element={<EmailConfirm />} />
              <Route path="/passwort-vergessen" element={<PasswordReset />} />
              <Route path="/passwort-festlegen" element={<SetPassword />} />
              <Route path="/selbst-buchen" element={<SelfServiceSignup />} />
              <Route path="/admin" element={<BoardAdmin />} />
              {/* Folgeprompt 16 (3.1): Alte Route /dashboard leitet dauerhaft auf
                  das konsolidierte Dashboard (/customerinfo) um. Die alte
                  BoardDashboard-Ansicht wird in Schritt 2 inhaltlich uebernommen. */}
              <Route path="/dashboard" element={<Navigate to="/customerinfo" replace />} />
              <Route path="/taxes" element={<BoardTaxes />} />
              <Route path="/mainvos" element={<BoardMainVos />} />
              <Route path="/areagroup" element={<BoardAreaGroup />} />
              <Route path="/areas" element={<BoardArea />} />
              <Route path="/currencies" element={<BoardCurrencies />} />
              <Route path="/services" element={<BoardServices />} />
              <Route path="/system-templates" element={<BoardSystemTemplates />} />
              <Route path="/api-konfiguration" element={<BoardApiConfig />} />
              <Route path="/ki-api" element={<BoardAiConfigs />} />
              <Route path="/ai-stammdaten" element={<BoardAiMasterData />} />
              <Route path="/system-reset" element={<BoardSystemReset />} />
              <Route path="/gerade-erzeugt-verwalten" element={<BoardSelfServiceLive />} />
              <Route path="/system-title-catalog" element={<BoardTitelKatalog scope="system" />} />
              <Route path="/form-templates" element={<BoardFormTemplates />} />
              <Route path="/system-document-types" element={<BoardDocumentTypes scope="system" />} />
              <Route path="/system-agreement-templates" element={<BoardVereinbarungstitel scope="system" />} />
              <Route path="/system-agreement-templates/new" element={<SystemVereinbarungsvorlage />} />
              <Route path="/system-agreement-templates/:id" element={<SystemVereinbarungsvorlage />} />
              <Route path="/produktion" element={<BoardProduction />} />
              <Route path="/statuses" element={<BoardStatus />} />
              <Route path="/transport-types" element={<BoardTransportTypes />} />
              <Route path="/start-credit-types" element={<BoardStartCreditTypes />} />
              <Route path="/roles" element={<BoardRoles />} />
              <Route path="/users" element={<BoardUsers />} />
              <Route path="/countries" element={<CountryManager />} />
              <Route path="/notifications" element={<BoardNotifications />} />
              <Route path="/placeholder-sync" element={<BoardPlaceholderSync />} /> 
              <Route path="/requestdata" element={<BoardRequestData />} />
              <Route path="/subvos" element={<BoardSubVos />} />
              <Route path="/tariffs" element={<BoardTariffs />} />
              <Route path="/batchcodesmaster" element={<BatchManager />} />
              <Route path="/batchcodes" element={<BoardBatchcodes />} />
              <Route path="/invoices" element={<InvoiceManager />} />
              <Route path="/invoice-settings" element={<BoardInvoiceSettings />} />
              <Route path="/document-types" element={<BoardDocumentTypes />} />
              {/* Folgeprompt 15: /customerinfo wird zum modernen Dashboard.
                  Die fruehere Roh-Ansicht bleibt additiv unter
                  /customerinfo-legacy erhalten (nichts entfernt). */}
              <Route path="/customerinfo" element={<Dashboard />} />
              <Route path="/customerinfo-legacy" element={<BoardCustomerInfo />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/adm" element={<BoardAdm />} />
              <Route path="/customer" element={<BoardCustomer />} />
              <Route path="/batchessubvos" element={<BoardBatchesSubvos />} />
              <Route path="/batchesordersubvos" element={<BoardBatchesOrderSubvos />} />
              <Route path="/subvoinvoicemanager" element={<BoardSubvoInvoiceManager />} />
              <Route path="/admmydata" element={<BoardMyDataADM />} />
              <Route path="/admbatches" element={<BatchCodeManager />} />
              <Route path="/admcustomer" element={<CustomerManagerADM />} />
              <Route path="/admbatchorder" element={<BatchOrderManagerADM />} />
              <Route path="/adminvoicemanager" element={<InvoiceManagerADM />} />
              <Route path="/admmypassword" element={<BoardChangeMyPasswordADM />} />
              <Route path="/demobatches" element={<BatchCodeDemoADM />} />
              <Route path="/mybatches" element={<BatchManagerCustomer />} />
              {/* Kunden-Menü „Einstellungen“: die Links existierten, die Routen fehlten.
                  Ohne diese Einträge fing die Catch-all-Route /:hash die Adressen ab
                  und BatchRedirect leitete sie nach /notfound um. */}
              <Route path="/employee" element={<BoardEmployee />} />
              <Route path="/mydata" element={<Navigate to="/account?tab=daten" replace />} />
              <Route path="/cmypassword" element={<BoardChangeMyPasswordCustomer />} />
              <Route path="/cstats" element={<CustomerClicks />} />
              <Route path="/cestats" element={<CustomerEmployeeClicks />} />
              <Route path="/clickmanager" element={<CustomerClickManager />} />
              <Route path="/myreviews" element={<CustomerReviewsPage />} />
              <Route path="/customervoicemanager" element={<InvoiceManagerCustomer />} />
              
              <Route path="/payment-methods" element={<S7MyPaymentMethods />} />
              <Route path="/agreements" element={<S8MyAgreements />} />
              <Route path="/agreements/new" element={<VereinbarungErstellen />} />
              <Route path="/agreements/:id/edit" element={<VereinbarungBearbeiten />} />
              <Route path="/agreements/:id" element={<VereinbarungDetail />} />
              <Route path="/agreement-titles" element={<BoardTitelKatalog scope="stage" />} /> {/* Stufen-Titel-Katalog (Aufgabe 2) */}
              <Route path="/email-templates" element={<S9MyEmailTemplates />} />

              {/* Sicherheits-Routen: verhindern, dass Login-Weiterleitungen oder
                  Fehlerseiten faelschlich in der Catch-all-Route (BatchRedirect)
                  landen. Additiv – bestehende Routen bleiben unveraendert. */}
              <Route path="/user" element={<BoardDashboard />} />
              <Route
                path="/notfound"
                element={
                  <div className="container mt-3">
                    <h3>Seite nicht gefunden</h3>
                    <p>Die angeforderte Seite oder der Link ist ungültig.</p>
                    <Link to="/">Zur Startseite</Link>
                  </div>
                }
              />

              {/* Sperr-Seite fuer gesperrte Chargen-Codes (vor der Catch-all-Route). */}
              <Route path="/gesperrt" element={<BatchLocked />} />

              {/* Oeffentliche Visitenkarten-Detailansicht (Vorbild oi.gg) */}
              <Route path="/v/:code" element={<BusinessCardDetail />} />
              <Route path="/visitenkarte/:code" element={<BusinessCardDetail />} />

              <Route path="/:hash" element={<BatchRedirect />} /> 
          </Routes>
          </div>
        </div>

        <UserSidebar />

        <Footer />

        <CookieConsent
          location="bottom"
          buttonText="Akzeptieren"
          style={{ background: "#333" }}
          buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
          expires={150}
        >
          Diese Website verwendet Cookies, um die Benutzerfreundlichkeit zu verbessern.{" "}
          <a href="/datenschutz" style={{ color: "#4e9f3d" }}>Erfahren Sie mehr</a>
        </CookieConsent>
    </>
  );
};

const App = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;